













































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class NotificationWithOutExit extends Vue { 
	@Prop(Function) public openNotifcation: any
	
	showNotification = false
	textNotification = ""
	iconStatus = ""
	iconColor = ""
	textStatus = ""

    openNotification (text: string, status: string) {
		this.showNotification = true
		
		if (status === "success") {
			this.iconStatus = "mdi-checkbox-marked-circle-outline"
			this.iconColor = "green"
		}
		if (status === "error") {
			this.iconStatus = "mdi-alert-octagon-outline"
			this.iconColor = "red darken-2"
		}
		if (status === "warning") {
			this.iconStatus = "mdi-alert-outline"
			this.iconColor = "orange darken-2"
		}
		this.textStatus = status.toUpperCase()
		this.textNotification = text
    }
}
